import Bowser from 'bowser';
import queryString from 'query-string';


// 这是一个临时方案，根据不同的 domain 返回不同的企业微信配置信息
// 待 boleme.net 域名完全废弃后，可省略这个判断，直接返回 false
export function isInBolemeDotNetDomain() {
    return window.location.host.indexOf('portal.boleme.net') !== -1;
}
export function getWXConfigByDomain() {
    let config = {};
    if (isInBolemeDotNetDomain()) {
        config.portalUrl = window.XCConfig.VUE_APP_PORTAL_URL;
        config.agentId = window.XCConfig.VUE_APP_WX_AGENTID;
    } else {
        config.portalUrl = window.XCConfig.VUE_APP_PORTAL_URL_NEW;
        config.agentId = window.XCConfig.VUE_APP_WX_AGENTID_NEW;
    }
    return config;
}

export function isDesktopWX(userAgent = '') {
    const browser = Bowser.getParser(userAgent);
    const platform = browser.getPlatformType();
    return userAgent.toLowerCase().indexOf('micromessenger') !== -1 && platform === 'desktop';
}

export function isMobileWX(userAgent = '') {
    const browser = Bowser.getParser(userAgent);
    const platform = browser.getPlatformType();
    return userAgent.toLowerCase().indexOf('micromessenger') !== -1 && platform !== 'desktop';
}

export function getWXOauthUrl(redirect = '', extraParams = {}) {
    const wxConfig = getWXConfigByDomain();

    let params = {
        agentId: wxConfig.agentId,
        from: 'wx',
        ...extraParams
    };
    if (typeof redirect !== 'undefined') {
        params['redirect'] = redirect;
    }

    let queryStr = queryString.stringify(params);
    const wxRedirectUrl = encodeURIComponent(`${wxConfig.portalUrl}/#/login?${queryStr}`);

    return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${
        window.XCConfig.VUE_APP_WX_APPID
    }&redirect_uri=${
        wxRedirectUrl
    }&response_type=code&scope=SCOPE&agentid=&state=STATE#wechat_redirect`;
}
